import React from 'react';

// import {makeStyles} from '@mui/styles';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

import Auth from '../../../data/auth-service';
import Permissions from '../../../data/permissions';

import DisplayCard from '../../../components/displaycard';

// const useStyles = makeStyles(theme => ({
//     card: {
//         maxWidth: 345,
//     },
// }));

const options = [
    {
        title: 'Audit Export(s)',
        description: 'Configure audit exports',
        img: '/images/audit.png',
        route: '/system/configuration/audit',
        perm: {
            AuditExport: [...Permissions.System.Configuration.AuditExport],
        },
    },
    {
        title: 'Authentication',
        description: 'Configure authentication, LDAP, SAML, and Okta',
        img: '/images/authentication.png',
        route: '/system/configuration/auth',
        perm: {
            AuthenticationStandard: [...Permissions.System.Configuration.AuthenticationStandard],
            AuthenticationPrivileged: [...Permissions.System.Configuration.AuthenticationPrivileged],
            AuthenticationExternal: [...Permissions.System.Configuration.AuthenticationExternal],
        },
    },
    {
        title: 'CMC Event Export(s)',
        description: 'Configure system exports',
        img: '/images/event.png',
        route: '/system/configuration/exports',
        perm: {
            CMCExport: [...Permissions.System.Configuration.CMCExport],
        },
    },
    {
        title: 'Health',
        description: 'Manage health update recipients',
        img: '/images/health.png',
        route: '/system/configuration/health',
        perm: {
            HealthAlerts: [...Permissions.System.Configuration.HealthAlerts],
        },
    },
    {
        title: 'Email',
        description: 'Review email logs and settings',
        img: '/images/email.png',
        route: '/system/configuration/email',
        perm: {
            Mail: [...Permissions.System.Configuration.Mail],
        },
    },
    {
        title: 'Proxy',
        description: 'Configure an HTTP proxy',
        img: '/images/proxy.png',
        route: '/system/configuration/proxy',
        perm: {
            Proxy: [...Permissions.System.Configuration.Proxy],
        },
    },
    {
        title: 'Reports',
        description: 'Manage report settings',
        img: '/images/reports.png',
        route: '/system/configuration/reports',
        perm: {
            ReportsConfig: [...Permissions.System.Configuration.ReportsConfig],
        },
    },
    {
        title: 'SNMP',
        description: 'Adjust SNMP settings and users',
        img: '/images/snmp.png',
        route: '/system/configuration/snmp',
        perm: {
            SNMP: [...Permissions.System.Configuration.SNMP],
        },
    },
    {
        title: 'UI',
        description: 'Change UI messages and lookup URLs',
        img: '/images/ui.png',
        route: '/system/configuration/ui',
        perm: {
            UI: [...Permissions.System.Configuration.UI],
        },
    },
    {
        title: 'VPN',
        description: 'Modify VPN settings',
        img: '/images/vpn.png',
        route: '/system/configuration/vpn',
        perm: {
            VPN: [...Permissions.System.Configuration.VPN],
        },
    },
    {
        title: 'OpenText™ NDR Support',
        description: 'Modify OpenText™ NDR Support settings',
        img: '/images/support.png',
        route: '/system/configuration/support',
        perm: {
            Support: [...Permissions.System.Configuration.Support],
        },
    },
    {
        title: 'Web Server',
        description: 'Manage web server settings',
        img: '/images/web.png',
        route: '/system/configuration/web',
        perm: {
            WebServer: [...Permissions.System.Configuration.WebServer],
        },
    },
    {
        title: 'Metadata Ingest',
        description: 'Manage Opensearch ingestion of Zeek metadata',
        img: '/images/proxy.png',
        route: '/system/configuration/eswd',
        perm: {
            MetadataIngest: [...Permissions.System.Configuration.MetadataIngest],
        },
    },
];

const Configuration = (props) => {
    // const classes = useStyles();

    return (
        <Box mb={2}>
            <Grid container spacing={5}>
                {options.filter(o => Auth.perm(o.perm)).map((p, i) => {
                    return (
                        <Grid item xl={3} lg={4} key={`policies-zeek-${i}`}>
                            <DisplayCard {...p} noButton />
                        </Grid>
                    );
                })}
            </Grid>
        </Box>
    );
};

export default Configuration;
